<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding edit-agent-level sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="$t('Agent_level')"
              prop="login"
            >
              <el-select
                style="width: 100%"
                v-model="form.level"
              >
                <el-option
                  v-for="(item,index) in ibList"
                  :key="index"
                  :label="item.levelName"
                  :value="item.levelId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="rule-module">
            <div
              class="bgc-box std"
              v-for="(content,index) in curentRule"
              :key="index"
            >
              <div class="title">{{content.mt4GroupNamme}}</div>
              <div
                v-for="(item,k) in content.symbolGroup"
                :key="k"
                class="line-flex-row">
                <div class="label">{{item.name}}</div>
                <div class="line-el"></div>
                <div class="data">{{getReadonlyText(item)}} {{getSuffix(item.suffix,item)}}</div>
              </div>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { editLevel } from '@/api/userCenter.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default {
  name: "editAgentLevelDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    ibList:{
      type: Array,
      default:[]
    },
    custId:{},
    currentCustLvl:{}
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('Modify_agent_level'),
      agentLevel: -1,
      // selfCustLvl: this.currentCustLvl,
      form: {
        // 取levelName
        level: _this.currentCustLvl,
      },
      rules:{
        level: [
          { required: true, message: _this.$t('root.selectPls'), trigger: 'change' },
        ]
      },
    }
  },
  created(){
  },
  watch: {
    dialogShow(){

    },
    currentCustLvl(newValue,oldValue){
      this.form.level = newValue;
    }
  },
  computed: {
    ...mapGetters(['userInfo','themeColor']),
    curentRule(){
      if(this.ibList.length){
        let curIndex = this.ibList.findIndex((item,index) => {
          return item.levelId == this.form.level;
        })
        if(curIndex > -1){
          // content 是数组
          return this.ibList[curIndex].content;
        }
      }else {
        return [];
      }
    }
  },
  methods: {
    getReadonlyText(item){
      if(item.max == -1){
        return '/'
      }
      return `${item.value}`;
    },
    getSuffix(suffix,colItem){
      if(colItem.max == -1){
        return '';
      }
      if(suffix === 1){
        return '$' + '/lot';
      }else if(suffix === 3){
        return 'pips' + '/lot'
      }
    },

    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    submitHandle(){
      if (!this.form.level) {
        this.$message({
          type: 'error',
          message: this.$t('select_rebate_level'),
        });
        return;
      }
      editLevel({
        custId: this.custId,
        levelId: this.form.level,
      }).then((res) => {
        this.$message({
          type: 'success',
          message: this.$t('editSuceess'),
        });
        this.$emit('refrash');
        this.close();
      })
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.edit-agent-level {
  .content {
    .rule-module {
      .bgc-box {
        background-color: #F8F8F8;
        padding: 10px;
        margin-bottom: 10px;
        .title {
          font-weight: 600;
          color: #5E5873;
        }
        .line-flex-row {
          margin: 8px 0;
          .data {
            font-size: 14px;
            color: #5E5873;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.edit-agent-level {
  .vs-sidebar--items {

  }
  // 高度滑动有点问题 todo
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
